"use strict";

var _classCallCheck = require("/Users/jere/Code/whitelist-standalone/node_modules/@babel/runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Wallet_1 = require("./Wallet");

var factories_1 = require("./entities/factories");
/**
 * Context in which the SDK is being used
 *
 * - Holds the current instance of the contract wrappers
 * - Holds the current wallet
 * - Holds the factories that create and cache entities
 */


var Context = // eslint-disable-next-line require-jsdoc
function Context(params) {
  _classCallCheck(this, Context);

  var contractWrappers = params.contractWrappers;
  this.contractWrappers = contractWrappers;
  this.currentWallet = new Wallet_1.Wallet({
    address: function address() {
      return contractWrappers.getAccount();
    }
  });
  this.factories = {
    securityTokenFactory: new factories_1.SecurityTokenFactory(this),
    securityTokenReservationFactory: new factories_1.SecurityTokenReservationFactory(this),
    erc20TokenBalanceFactory: new factories_1.Erc20TokenBalanceFactory(this),
    investmentFactory: new factories_1.InvestmentFactory(this),
    simpleStoFactory: new factories_1.SimpleStoFactory(this),
    tieredStoFactory: new factories_1.TieredStoFactory(this),
    dividendDistributionFactory: new factories_1.DividendDistributionFactory(this),
    checkpointFactory: new factories_1.CheckpointFactory(this),
    tokenholderFactory: new factories_1.TokenholderFactory(this),
    taxWithholdingFactory: new factories_1.TaxWithholdingFactory(this)
  };
};

exports.Context = Context;